import { MarketSortOption } from '@/constants/sort';
import apiClient from '../../apiClient';

export type ReqGetNewProducts = {
  query: {
    isPickUp?: boolean;
    isDeliveryFree?: boolean;
    isDiscount?: boolean;
    minPrice?: number;
    maxPrice?: number;
    province?: string;
    city?: string;
    villageName?: string;
    sortOption?: MarketSortOption | null;
  };
  page?: number;
};

export interface NewProductContent {
  id: number;
  createdAt: string;
  platformType: string;
  villageName: string;
  categoryId: string;
  categoryName: string;
  marketProductName: string;
  approvalStatus: string;
  businessName: string;
  originPrice: number;
  price: number;
  discountRate: number;
  thumbnailUrl: string;
  deliveryFee: number;
  isDeliveryFree: boolean;
  tagList: string[];
  label: string;
  state: string;
  isPickUp: boolean;
  stockAvailable: number;
  salesCount: number;
  reviewRate: number;
}

export type ResGetNewProducts = PaginationResponse<NewProductContent>;

const getNewProducts = async ({ page, query }: ReqGetNewProducts): Promise<ResGetNewProducts> => {
  // URLSearchParams를 사용하여 쿼리 문자열 생성
  const params = new URLSearchParams();
  if (page !== undefined) {
    params.append('page', page.toString());
  }
  // query 객체의 각 속성을 개별 쿼리 파라미터로 추가
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      params.append(key, value.toString()); // 숫자나 불리언 값도 문자열로 변환
    }
  });

  params.append('platformType', 'GROUND');
  const { data } = await apiClient.get<ResGetNewProducts>(
    `/app/market-products/new?${params.toString()}`
  );
  return data;
};

export default getNewProducts;
